import * as Sentry from "@sentry/react";
import AxiosHttpClient from "./HttpClient";
import Logger from "./Logger";
export var SentryEnvs;
(function (SentryEnvs) {
    SentryEnvs["DEV"] = "development";
    SentryEnvs["STAGE"] = "stage";
    SentryEnvs["PROD"] = "production";
})(SentryEnvs || (SentryEnvs = {}));
const TAG = 'SentrySDKUtils';
const SENTRY_USER_API = '/intel/v1/users/me';
export default class SentrySDK {
    static getEnvironment() {
        const hostname = window.location.hostname;
        // Match both the legacy dash.* and new max.* hosts during the domain migration.
        if (/(stage-dash\.applovin\.com|stage-max\.applovin\.com|stage-applovin\.com)/.test(hostname)) {
            return SentryEnvs.STAGE;
        }
        else if (/(dash\.applovin\.com|max\.applovin\.com)/.test(hostname)) {
            return SentryEnvs.PROD;
        }
        return SentryEnvs.DEV;
    }
    static catchAPIError(error) {
        if (this.isSentryInitialized()) {
            Sentry.captureException(error);
        }
    }
    static captureMessage(message, logLevel, extras, tags = {}) {
        if (this.isSentryInitialized()) {
            Sentry.captureMessage(message, {
                level: logLevel,
                extra: {
                    logId: extras.logId
                },
                tags: tags
            });
        }
    }
    static sessionReplayInit(initOptions = {}) {
        if (!this.isInitialized) {
            const sentryEnv = initOptions.environment || this.getEnvironment();
            const maskAllText = initOptions.maskAllText !== undefined ? initOptions.maskAllText : true;
            const blockAllMedia = initOptions.blockAllMedia !== undefined ? initOptions.blockAllMedia : true;
            // Always sample 50% in DEV & STAGE and 5% in PROD
            const sessionSampleRate = sentryEnv !== SentryEnvs.PROD ? 0.5 : 0.05;
            const onErrorSampleRate = 1.0;
            Sentry.init({
                dsn: "https://62f3f66676ed44f5216dd413f6e98b29@o4504501031403520.ingest.sentry.io/4506599902871552",
                integrations: [
                    Sentry.replayIntegration({
                        maskAllText: maskAllText,
                        blockAllMedia: blockAllMedia,
                        workerUrl: "/assets/sentry/js/worker.min.js"
                    }),
                ],
                // Session Replay
                replaysSessionSampleRate: sessionSampleRate,
                replaysOnErrorSampleRate: onErrorSampleRate,
                environment: sentryEnv
            });
            this.maybeSetSentryUserId();
            SentrySDK.isInitialized = true;
        }
    }
    static isSentryInitialized() {
        return SentrySDK.isInitialized;
    }
    static setReplayUserId(userId) {
        if (this.isSentryInitialized()) {
            Sentry.setUser({ id: userId });
        }
    }
    static maybeSetSentryUserId() {
        const requestUrl = `${SENTRY_USER_API}`;
        const client = new AxiosHttpClient();
        Logger.info(TAG, `Fetching users from ${requestUrl}...`);
        client.get(requestUrl).then((res) => {
            if (res.user)
                this.setReplayUserId(res.user.id);
        });
    }
}
SentrySDK.isInitialized = false;
//# sourceMappingURL=SentrySDK.js.map